import { alpha, TextField, Theme } from "@mui/material";
import { Todo } from "../../../../../types/types";
import { StyledEventItem } from "../../../styles/styles";
import SaveButton from "../../SaveButton";

interface EditTodoFieldProps {
    editingText: string;
    setEditingText: (text: string) => void;
    onSave: () => void;
    getTodoColor: (todo: Todo, theme: Theme) => string | undefined;
    theme: Theme;
}

export const EditTodoField: React.FC<EditTodoFieldProps> = ({
    editingText,
    setEditingText,
    onSave,
    getTodoColor,
    theme
}) => (
    <StyledEventItem
        bgcolor={getTodoColor({ priority: "low" } as Todo, theme) || 'primary.main'}
        isEditing={true}
        onBlur={onSave}
        sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            position: 'relative',
        }}
    >
        <TextField
            autoFocus
            multiline
            value={editingText}
            onChange={(e) => setEditingText(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === 'Enter') onSave();
            }}
            placeholder="Todo"
            variant="standard"
            sx={{
                width: '100%',
                color: theme.palette.text.primary,
                paddingRight: '4px',
                '& .MuiInputBase-root': {
                    '&::before, &::after': {
                        color: "common.black",
                        borderColor: theme => alpha(theme.palette.common.black, 0.5),
                    },
                },
                '& .MuiInputBase-input': {
                    padding: 0,
                    fontSize: theme.typography.caption.fontSize,
                    lineHeight: theme.typography.caption.lineHeight,
                    '&:focus': {
                        background: 'none',
                    },
                },
                [theme.breakpoints.down('md')]: {
                    fontSize: '0.3rem',
                },
                [theme.breakpoints.down('sm')]: {
                    paddingRight: 0
                },
            }}
        />
        <SaveButton
            onSave={onSave}
            disabled={editingText.length === 0}
            sx={{
                [theme.breakpoints.down('sm')]: {
                    display: 'none',
                },
            }}
        />
    </StyledEventItem>
); 